import { auth } from '../lib/firebase'
import {
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signOut,
  UserCredential,
  GoogleAuthProvider,
  signInWithPopup,
} from 'firebase/auth'
import { post } from './api'

const googleProvider = new GoogleAuthProvider()
googleProvider.setCustomParameters({
  prompt: 'select_account',
})

export async function signUpWithEmailPassword(email: string, password: string): Promise<UserCredential> {
  return createUserWithEmailAndPassword(auth, email, password)
}

export async function signInWithEmailPassword(email: string, password: string): Promise<UserCredential> {
  return signInWithEmailAndPassword(auth, email, password)
}

export async function signInWithGoogle(): Promise<UserCredential> {
  try {
    return await signInWithPopup(auth, googleProvider)
  } catch (error: any) {
    // Provide a more actionable message for popup issues to display in the UI
    if (error?.code === 'auth/popup-blocked') {
      throw new Error('Your browser blocked the Google sign-in popup. Please allow popups for this site and try again.')
    }
    throw error
  }
}

export async function signOutFirebase(): Promise<void> {
  return signOut(auth)
}

export async function ensureUserProfileOnBackend(): Promise<{ user: any }> {
  const token = await auth.currentUser?.getIdToken()
  if (!token) throw new Error('Not authenticated')

  // Use raw fetch via post helper with Authorization header support
  const res = await fetch(`${import.meta.env.VITE_API_BASE_URL || 'http://localhost:3001/api'}/user/ensure`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  })
  const data = await res.json()
  if (!res.ok || !data.success) {
    throw new Error(data?.error?.message || 'Failed to ensure user profile')
  }
  return data.data
}
